import { Injectable } from '@angular/core';
import {Router, CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { UserService } from './user.service';

@Injectable()
export class AuthGuardService implements CanActivate, CanActivateChild {

  constructor(public auth: UserService, public router: Router) {}

  async canActivate(){
    if (!this.auth.isAuthenticated()) {
      try{
        await this.auth.refreshTokens();
        if(!this.auth.isAuthenticated()){
          console.log("could not refresh (not error)")
          await this.router.navigate(['login']);
          return false;
        }
        return true;
      } catch(e){
        alert("Could not refresh tokens, please login again.")
        await this.router.navigate(['login']);
        return false;
      }
    }
    return true;
  }

  async canActivateChild() {
    return await this.canActivate();
  }
}
